import { notification } from "antd";

const NotificationWithIcon = (type, message, description = "") => {
  notification[type]({
    message: message,
    description: description,
  });
};

export default NotificationWithIcon;
